import React from 'react';
import PropTypes from 'prop-types';
import Image from './Image.jsx';
import options from '../data/options.json';
import t from './utils/i18n.js';


export default class Cards extends React.Component {
    constructor(props) {
        super(props);
        this.courseTypes = {
            's': 'Kortkurs',
            'hv': 'Halvår — vår',
            'hh': 'Halvår — høst',
            'w': 'Helårskurs',
        };
        this.stateTypes = {
            '0': 'Ledig plass',
            '1': 'Full',
            '2': 'Venteliste',
            '3': 'Kontakt skolen',
            '4': 'Få ledige plasser',
        };
        this.pageSize = 35;
        this.priceBrackets = {};
        props.prices.map((price, index) => {
            if (price.key) {
                this.priceBrackets[price.key] = index;
            }
        });
        this.state = {
            containerRef: React.createRef(),
            filterBtnSticky: false,
            loadedCourses: [],
            limit: props.limit
        };
        this.loadMore = this.loadMore.bind(this);

        if (this.props.standalone) {
            this.state.loadedCourses = props.courses.slice(0, this.props.limit);
            this.courseOffset = this.pageSize;
            this.courseOffset = 0;
        }
    }

    loadMore() {
        if (this.props.standalone) {
            let newLimit = this.state.limit + this.pageSize;
            let courses = this.props.courses.slice(0, newLimit);
            this.setState({
                loadedCourses: courses,
                limit: newLimit
            });
        } else {
            return this.props.loadMore(this.pageSize);
        }
    }

    componentDidUpdate() {
        if (this.props.standalone) {
            return;
        }
        const callbackFunction = (entries) => {
            const [ entry ] = entries;
            let newValue = (entry.intersectionRatio > 0);
            if (newValue != this.state.filterBtnSticky) {
                this.state.filterBtnSticky = newValue;
                this.forceUpdate();
            }
        }

        const options = {
            rootMargin: "0px 0px -99% 0px"
        };

        const observer = new IntersectionObserver(callbackFunction, options);
        if (this.state.containerRef.current) {
            observer.observe(this.state.containerRef.current);
        }

        return () => {
            if (this.state.containerRef.current) {
                observer.unobserve(this.state.containerRef.current);
            }
        }
    }

    scrollToFilters() {
        document.getElementById('course-filtering').scrollIntoView({ behavior: 'smooth' });
    }

    render() {
        const renderCourses = (course, index) => {
            if (course === undefined) {
                return false;
            }

            let priceClass = false;
            let priceText = '';
            if (course.price !== undefined && (this.priceBrackets[course.price] !== undefined)) {
                let priceBracket = this.priceBrackets[course.price];
                priceClass = "card__icon card__icon__price card__icon__price--" + (priceBracket + 1);
                priceText = options.courses.price[priceBracket].name;
            }

            const hasStatus = (course.status !== '' && course.status);
            let firstHalfyearCourse = false;

            if (isWholeYear && course.coursetype !== 'w') {
                isWholeYear = false;
                firstHalfyearCourse = true;
            }

            return (
                <a href={course.url} key={index} className="card__item" id={firstHalfyearCourse ? 'halvarslinjer' : ('linje-' + index)}>
                    <div className="card__text">
                        <h2>{course.coursename}</h2>
                        <div className={'card__school' + (hasStatus ? ' card__school--has-status' : '')}>{course.schoolname}, {course.county}</div>
                    </div>
                    { hasStatus ? (
                        <span className={'coursestatus coursestatus--'+course.status}>{ t(this.stateTypes[course.status], this.props.lang) }</span>
                    ) : null }
                    <div className="card__icons">
                        <div className={'card__icon card__icon__type card__icon__type--' + course.coursetype}>{ t(this.courseTypes[course.coursetype], this.props.lang) }</div>
                        {/*
                        {course.h ?
                            <div className="card__icon card__icon__teaching">{course.h} <span>{t("t/uke", this.props.lang)}</span></div>
                        : null}
                         */}
                        {priceClass ?
                            <div className={priceClass} role="img" aria-label={priceText ? 'Pris: ' + priceText + ' kr' : ''}></div>
                        : null}
                        {course.christian ?
                            <div className="card__icon card__icon__religion card__icon__religion--christian">{t("Kristen", this.props.lang)}</div>
                        : <div className="card__icon card__icon__religion card__icon__religion--atheist">{t("Frilynt", this.props.lang)}</div> }
                    </div>
                    <Image src={course.courseimage} alt="" />
                </a>
            );
        };


        let list;
        let isWholeYear = true;

        if (this.props.standalone) {
            list = this.state.loadedCourses.map(renderCourses);
        } else {
            list = this.props.courses.map(renderCourses);
        }

        return (
            <div className="card__container">
                { !this.props.standalone ? (
                    <div className={'card__filters ' + (this.state.filterBtnSticky ? 'card__filters--stuck' : 'card__filters--unstuck')}><button tabindex="-1" className="button button--opaque" onClick={(e) => this.scrollToFilters()}>{t("Endre filtrering", this.props.lang)}</button></div>
                ) : null }
                <div className={'card__wrapper card__wrapper--coursesearch' + (this.props.standalone ? ' card__wrapper--standalone' : '')} ref={this.state.containerRef}>
                    {list}
                </div>
                <div className="card__loadmore">
                    {(this.props.standalone ? (this.props.total > this.state.limit) : (this.props.total > this.props.limit)) ?
                        (
                            <button className="button button--primary button--loadmore" onClick={() => this.loadMore()}>{t("Vis flere", this.props.lang)}</button>
                        )
                        : ''
                    }
                </div>
            </div>
        );
    }
}

Cards.propTypes = {
    courses: PropTypes.array.isRequired,
    prices: PropTypes.array.isRequired,
    lang: PropTypes.string,
    standalone: PropTypes.bool,
    limit: PropTypes.number,
    total: PropTypes.number,
    loadMore: PropTypes.func
};
